import React, { Fragment, useState, useEffect } from "react"
import { CSSTransition } from "react-transition-group"
import queryString from "query-string"
import { ReviewView } from "./components/ReviewView"
import HowItWorksView from "./components/HowItWorksView"
import ThankYouView from "./components/ThankYouView"
import StatusView from "./components/StatusView"

import { SetReminderWrapper } from "./components/SetReminderWrapper"
import { scrollToTopOfCurrentStep } from "services/break"

import { submit, requestEmailReminder, getSubmissionStatus } from "services/video-upload"

import analytics from "global/AnalyticsData"

import "./UGCVideoUploadStep.scss"
import "./UGCVideoUploadStepMobile.scss"

const UGCVideoUploadStep = ({ breakId, step, service, onEngage = function () {}, onAwardPoints = function () {}, onChangeBackground = function () {}, skipButton, nextStepButton, onStepSkip, themeColors, handleInstantWinEvent = null }) => {
  const [position, setPosition] = useState(0)
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [uploadID, setUploadID] = useState(null)
  const [nonFieldErrors, setNonFieldErrors] = useState([])

  const [filesArray, setFilesArray] = useState([])
  const [uploadError, setUploadError] = useState(null)
  //populated with user submission if already submitted; if null, then they're doing it for the first time.
  const [userSubmission, setUserSubmission] = useState(null)
  //A bit dirty, but this shows us the step is loaded.
  const [rewardSelected, setRewardSelected] = useState(null)

  const [reminderFormSent, setReminderFormSent] = useState(false)
  const [receiptSubmissionId, setReceiptSubmissionId] = useState("") // something weird on API side. This has to initially be '', not null or undefined

  const [loaded, setLoaded] = useState(false) //true after we check the status of the receipt submission
  const [previousSubmissionStatus, setPreviousSubmissionStatus] = useState(null)

  const scrollToTopOfBrokenAssJsonCustomStep = () => {
    scrollToTopOfCurrentStep(step.id)
  }

  useEffect(() => {
    if (position > 0) {
      scrollToTopOfBrokenAssJsonCustomStep()
    }
  }, [position])

  useEffect(() => {
    analytics.stepEvent("")
  })

  const tryToGetToken = (tokenName = "token") => {
    try {
      let qs = queryString.parse(window.location.search)
      if (qs[tokenName]) {
        return qs[tokenName]
      } else {
        return null
      }
    } catch (e) {
      return null
    }
  }

  useEffect(() => {
    if (handleInstantWinEvent && previousSubmissionStatus) {
      handleInstantWinEvent({
        eventName: `receipt-submission-status-${previousSubmissionStatus.status}`.toLowerCase(),
        context: { receiptStatusResult: previousSubmissionStatus.fullResponse, stepId: step.id },
      })
    }
  }, [previousSubmissionStatus, handleInstantWinEvent])

  const attemptToRetrievePendingSubmission = async token => {
    try {
      let theToken = await tryToGetToken("token")

      if (theToken !== null) {
        const statusResult = await getSubmissionStatus({
          breakId: breakId,
          stepId: step.id,
          token: theToken,
          receiptId: stepData.id,
        })
        const { status, rewardId, email, breakId, firstName, lastName, address1, address2, city, state, postalCode, phoneNumber } = statusResult
        if (typeof status === "string") {
          const chosenReward = step.receiptVerificationCampaign.rewards.find(reward => {
            return reward.id === rewardId
          })

          await setPreviousSubmissionStatus({ status: status, reward: chosenReward, fullResponse: statusResult })
          onEngage()

          await setLoaded(true) // fire this to load up the ui
        }
      }
    } catch (e) {
      console.log(e)
    }
    await setLoaded(true)
  }

  const returningFromReminder = async token => {
    try {
      let theToken = await tryToGetToken()
      if (theToken !== null) {
      }
    } catch (e) {
      console.log(e)
    }
    await setLoaded(true)
  }

  //check to see if user is coming from email.
  useEffect(() => {
    attemptToRetrievePendingSubmission()
  }, [])

  const animationDuration = 400
  const stepData = step.receiptVerificationCampaign || step.mediaUploadCampaign

  //clicking "not yet" skips step
  const handleSkipReceipt = function () {
    analytics.stepEvent("step_step_interaction_skip_click", step)
    onStepSkip && onStepSkip()
  }

  const handleUploadError = function (error) {
    setUploadError(error)
  }

  const handleFileSelection = filesList => {
    const files = [...filesList]
    console.log(`handleFileOutput`, files)
    setPosition(1)
    setFilesArray(files)
  }

  const handleFileUploadSuccess = async uploadId => {
    console.log(`top of template: upload success: ${uploadId}`)
    setUploadSuccess(true)
    setUploadID(uploadId)
  }
  const handleRemoveUpload = async index => {
    setFilesArray([])
  }

  const editMySubmission = () => {
    setPosition(position - 1)
  }

  const handleTheFormSubmission = async values => {
    const rewardSelectedLocal = stepData.rewards.find(reward => reward.id === values.rewardId)
    const submissionObject = {
      breakId: breakId,
      stepId: step.id,
      receiptId: step.receiptVerificationCampaign.id,
      receiptSubmissionId: receiptSubmissionId,
      uploadFile: uploadID,
      title: values.pet_name,
      zip_code: values.postalCode,
      ...values,
    }

    console.log(`submissionObject`, submissionObject)

    const response = await submit(submissionObject)

    setRewardSelected(rewardSelectedLocal)
    setPosition(position + 1)
    onEngage()
  }

  //Review form parses validation, if it passes, this function runs.

  //this is a wrapper function for the original function due to instant win.
  const handleFormSubmission = async values => {
    analytics.stepEvent("step_interaction_submite", step, {
      source: "UGC",
      type: "video",
    })
    handleTheFormSubmission(values)
  }

  const handleRequestReminder = async email => {
    analytics.stepEvent("step_interaction_reminder_submit", step)
    if (window !== undefined) {
      try {
        const link = window.location.href
        const resp = await requestEmailReminder(breakId, step.id, step.receiptVerificationCampaign.id, email, link)
        resp.status === 200 ? setReminderFormSent(true) : setReminderFormSent(false)
        setReminderFormSent(true)
        onEngage()
        onAwardPoints()
      } catch (e) {
        console.log(`issue submitting reminder form: ${e}`)
      }
    }
  }
  const handleStatusRetrieved = async status => {
    if (status === "approved") {
      //This ask is weird so it deserves a weird solution
      analytics.stepEvent("step_interaction_receipt_approval", step)
    }
    if (status === "rejected") {
      analytics.stepEvent("step_interaction_receipt_rejection", step)
    }
  }

  const stepViewArray = [
    <HowItWorksView onUploadError={handleUploadError} themeColors={themeColors} handleFileSelection={handleFileSelection} setPosition={setPosition} headerImage={stepData.headerImage} headline={stepData.headline} introCopy={stepData.introCopy} userPathHeadline={stepData.userPathHeadline} instructions={stepData.instructions} skipReceipt={handleSkipReceipt} />,
    <ReviewView uploadID={uploadID} uploadSuccessful={uploadSuccess} onUploadSuccessful={handleFileUploadSuccess} onUploadError={handleUploadError} handleFileSelection={handleFileSelection} onRemove={handleRemoveUpload} headerTitle={stepData.reviewHeader} headerSubtitle={stepData.reviewCopy} reviewListHeader={stepData.reviewListHeader} instructions={stepData.detailedInstructions} rewardOptions={stepData.rewards} onFormSubmission={handleFormSubmission} editMySubmission={editMySubmission} files={filesArray} nonFieldErrors={nonFieldErrors} />,
    <>{rewardSelected && <ThankYouView step={step} headline={rewardSelected.thankyouHeader} bodyCopy={rewardSelected.thankyouBody} image={rewardSelected.rewardImage} />} </>,
    <SetReminderWrapper
      goBackToStart={() => {
        setPosition(0)
        scrollToTopOfBrokenAssJsonCustomStep()
      }}
      setPosition={setPosition}
      requestReminder={handleRequestReminder}
      reminderFormSent={reminderFormSent}
      reminderHeader={stepData.reminderHeader}
      reminderCopy={stepData.reminderCopy}
      reminderThanksHeader={stepData.reminderThanksHeader}
      reminderThanksCopy={stepData.reminderThanksCopy}
      headerImage={stepData.headerImage}
      instructionsHeader={stepData.reminderThanksInstructionsHeader}
      instructions={stepData.reminderInstructions}
    />,
  ]

  return (
    <>
      <section className="receipt-verification-step video-ugc">
        <>
          <div className="step-content with-shadow">
            <div className="step-view-container will-fade-transition-container">
              {previousSubmissionStatus === null ? (
                <>
                  {stepViewArray.map((component, i) => {
                    return (
                      <CSSTransition key={i} in={position === i} timeout={animationDuration} className={`will-fade-transition ${position === i ? "is-active" : "is-inactive"}`}>
                        <div>{position === i && <Fragment key={`receipt-transition-view-item-${i}`}>{component}</Fragment>}</div>
                      </CSSTransition>
                    )
                  })}
                </>
              ) : (
                <StatusView status={previousSubmissionStatus.status} reward={previousSubmissionStatus.reward} onStatusRetrieved={handleStatusRetrieved} />
              )}
            </div>
            {stepData.stepTerms && (
              <div className={`legal-text-container`}>
                <p dangerouslySetInnerHTML={{ __html: stepData.stepTerms }} />
              </div>
            )}
          </div>
        </>
      </section>
    </>
  )
}

export default UGCVideoUploadStep
